import { GetterTree, ActionTree, MutationTree } from "vuex";

export class ReservationModalState {
    guestsUnchanged = true;
}

const initialState = new ReservationModalState();

const state = { ...initialState };

const getters: GetterTree<ReservationModalState, any> = {
  guestsUnchanged: (s) => s.guestsUnchanged,
};
const actions: ActionTree<ReservationModalState, any> = {
  setGuestsUnchanged({commit}, payload: boolean) {
      commit("setGuestsUnchanged", payload);
  },
};
const mutations: MutationTree<ReservationModalState> = {
    setGuestsUnchanged: (state, value: boolean) => {
        state.guestsUnchanged = value;
    },
};

export default {
  namespaced: true,
  state: () => state,
  getters,
  actions,
  mutations
};
